import { useWidth } from "./use-width.hook";

function useMediaQuery() {
  const width = useWidth();
  return {
    isMobile: ["xs", "sm"].includes(width),
    isTablet: ["md"].includes(width),
    isDesktop: ["lg", "xl"].includes(width),
    xs: width === "xs",
    sm: width === "sm",
    md: width === "md",
    lg: width === "lg",
    xl: width === "xl"
  };
}

export default useMediaQuery;
